import React from "react";
import HeroSection from "../components/hero/HeroSection";
import ServiceHub from "../components/service/ServiceHub";
import AboutSection from "../components/common/AboutSection";

export default function Home() {
  return (
    <div style={{ paddingBottom: '4rem' }}>
      <HeroSection />
      <ServiceHub />
      <AboutSection />
    </div>
  );
}
